import { TimelineStep } from '@websky/graphql';
import { addMinutes, parse, setHours, setMinutes } from 'date-fns';
import { API_DATE_FORMAT, capitalizeFirstLetter, format } from '../../../../utils';
import { TravellerFieldEnum } from '@websky/graphql';
export const TO_AIRPORT_INTERNATIONAL_BEFORE_DEPARTURE = 160;
export const TO_AIRPORT_DOMESTIC_BEFORE_DEPARTURE = 90;
const getDefaultTimeline = (international) => [
    {
        type: TimelineStep.ToAirport,
        relatedTypes: [TimelineStep.ToAirport],
        minutes: {
            from: international ? TO_AIRPORT_INTERNATIONAL_BEFORE_DEPARTURE : TO_AIRPORT_DOMESTIC_BEFORE_DEPARTURE,
            to: international ? TO_AIRPORT_INTERNATIONAL_BEFORE_DEPARTURE : TO_AIRPORT_DOMESTIC_BEFORE_DEPARTURE
        }
    },
    {
        type: TimelineStep.Airport,
        relatedTypes: [TimelineStep.Airport],
        minutes: {
            from: international ? TO_AIRPORT_INTERNATIONAL_BEFORE_DEPARTURE : TO_AIRPORT_DOMESTIC_BEFORE_DEPARTURE,
            to: 40
        }
    },
    {
        type: TimelineStep.Boarding,
        relatedTypes: [TimelineStep.Boarding, TimelineStep.Flight],
        minutes: {
            from: 40,
            to: 20
        }
    },
    {
        type: TimelineStep.Landing,
        relatedTypes: [TimelineStep.Landing, TimelineStep.FromAirport],
        minutes: {
            from: 0,
            to: 0
        }
    },
    {
        type: 'InCity',
        relatedTypes: ['InCity'],
        minutes: {
            from: 0,
            to: 0
        }
    }
];
export const checkInternationalSegment = (segment) => {
    var _a, _b, _c, _d, _e, _f;
    return ((_c = (_b = (_a = segment.departure) === null || _a === void 0 ? void 0 : _a.airport) === null || _b === void 0 ? void 0 : _b.country) === null || _c === void 0 ? void 0 : _c.id) !== ((_f = (_e = (_d = segment.arrival) === null || _d === void 0 ? void 0 : _d.airport) === null || _e === void 0 ? void 0 : _e.country) === null || _f === void 0 ? void 0 : _f.id);
};
export const getTimeline = (servicesGroup, segmentId, international) => {
    return getDefaultTimeline(international).map(timeline => {
        return Object.assign(Object.assign({}, timeline), { services: servicesGroup.services.filter(service => timeline.relatedTypes.includes(service.step)), segmentId });
    });
};
export const getSuggestedServices = (servicesGroup, suggestedServicesOrder) => {
    return servicesGroup.services
        .filter(service => suggestedServicesOrder.hasOwnProperty(service.type) &&
        (service.canAddService || !!service.selectedServices.length))
        .sort((a, b) => suggestedServicesOrder[b.type] - suggestedServicesOrder[a.type]);
};
export const addTime = (time, minutesAmount, targetDate) => {
    let date = new Date();
    if (targetDate) {
        date = parse(targetDate, API_DATE_FORMAT, new Date());
    }
    const [hours, minutes] = time.split(':');
    date = setHours(date, parseInt(hours));
    date = setMinutes(date, parseInt(minutes));
    return addMinutes(date, minutesAmount);
};
export const getTime = (date) => {
    return format(date, 'HH:mm');
};
export const getTravellersValues = (travellers, customer) => {
    var _a, _b;
    const customerPhone = (_a = customer.find(value => value.type === TravellerFieldEnum.Phone)) === null || _a === void 0 ? void 0 : _a.value, customerEmail = (_b = customer.find(value => value.type === TravellerFieldEnum.Email)) === null || _b === void 0 ? void 0 : _b.value;
    return travellers.map(passenger => {
        const traveller = {
            id: passenger.id,
            firstname: '',
            lastname: '',
            date_of_birth: '',
            passport_id: '',
            patronymic: '',
            email: customerEmail,
            phone_number: customerPhone
        };
        passenger.values.forEach(value => {
            var _a, _b, _c;
            switch (value.type) {
                case TravellerFieldEnum.LastName:
                    traveller.lastname = capitalizeFirstLetter((_a = value.value) === null || _a === void 0 ? void 0 : _a.toLowerCase());
                    break;
                case TravellerFieldEnum.FirstName:
                    traveller.firstname = capitalizeFirstLetter((_b = value.value) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                    break;
                case TravellerFieldEnum.MiddleName:
                    traveller.patronymic = capitalizeFirstLetter((_c = value.value) === null || _c === void 0 ? void 0 : _c.toLowerCase());
                    break;
                case TravellerFieldEnum.BirthDate:
                    traveller.date_of_birth = value.value;
                    break;
                case TravellerFieldEnum.DocNumber:
                    traveller.passport_id = value.value;
                    break;
                case TravellerFieldEnum.Email:
                    traveller.email = value.value ? value.value : traveller.email;
                    break;
                case TravellerFieldEnum.Phone:
                    traveller.phone_number = value.value ? value.value : traveller.phone_number;
            }
        });
        return traveller;
    });
};
